import * as React from 'react';
import {COutlookTask} from '../../Entity/OutlookTaskObj';
import OutlookTask from './outlookTask';
import './Task.scss';

export interface IProps{
    data:COutlookTask[]; 
    UpdateToDoItem;  
    Phrases;
    usertimezone;
}
export default class OutlookTaskList extends React.Component<IProps>{
    constructor(props) {
        super(props);
      }
    public render() {
       
        return (              
        <div className='TODO'>      
             {this.props.data.map((obj, index)=>{
                    return (<OutlookTask UpdateToDoItem={this.props.UpdateToDoItem} 
                        data={obj} 
                        key={obj.id} 
                        Phrases={this.props.Phrases}
                        usertimezone={this.props.usertimezone}
                        />);
                  })}
         </div> 
        );
      }
}